import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Headline = () => {
  const { t } = useTranslation();

  return (
    <>
      <h1 className='slide-title animated '>{t('sliderArea.title')}</h1>
      <div className='slide-brief animated'>
        <p>{t('sliderArea.brief')}</p>
      </div>
      <div className='btn-wrapper animated'>
        <Link to='/request-property' className='theme-btn-1 btn btn-effect-1'>
          {t('sliderArea.makeEnquiry')}
        </Link>
      </div>
    </>
  );
};
